import { Grid, Stack, Typography } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

import { Company, Icon, Loading } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { PartnerCompanyTypeChip } from '@components';
import {
  PLAN_TYPE_COLOR,
  PLAN_TYPE_NAME,
} from '@flows/private/partnerCompanies/pages/PartnerCompanyList/constants/contractTypeEnum';
import { CompanyDetailsRouter } from '@flows/private/companies/pages/CompanyDetails/router';

import { ActionButton, Line, StyledGrid } from './styles';
import { CompanyListMobileProps } from './types';

export function CompanyListCardMobile({
  companyListData,
  hasNextPage,
  fetchNextPage,
}: Readonly<CompanyListMobileProps>) {
  const navigateTo = useNavigate();

  const companiesData =
    companyListData?.pages?.map(company => company.companies).flat() ?? [];

  const handleEdit = useCallback(
    (id: string) => {
      navigateTo(CompanyDetailsRouter.dynamicPath({ id }));
    },
    [navigateTo],
  );

  return (
    <InfiniteScroll
      dataLength={companiesData?.length}
      hasMore={!!hasNextPage}
      next={fetchNextPage}
      loader={<Loading animationProps={{ height: 20, width: 20 }} />}
      height={'800px'}
    >
      <Grid container gap={1} flexDirection="row" flexWrap="wrap">
        {companiesData?.map(company => (
          <Grid item xs={12} key={company?.id}>
            <Line container alignItems="center">
              <Stack
                flexDirection="row"
                alignItems="flex-start"
                mb={2}
                width="100%"
                justifyContent="space-between"
              >
                <Stack
                  alignItems="flex-start"
                  justifyContent="flex-start"
                  gap={1.5}
                >
                  <Stack alignItems="center" flexDirection="row" gap={1}>
                    <Typography fontWeight={700}>
                      {company?.partnerCompany}
                    </Typography>
                    <PartnerCompanyTypeChip
                      fontSize="12px"
                      isMainPartnerCompany={company?.isMainPartnerCompany}
                      size="small"
                    />
                  </Stack>
                  {company?.name.legal && (
                    <Typography
                      fontWeight={700}
                      textTransform="uppercase"
                      variant="text"
                      title={company?.name.legal}
                    >
                      {company?.name.legal}
                    </Typography>
                  )}
                  <Company company={company?.healthOperator ?? ''} />
                </Stack>
                <Stack
                  alignItems="flex-end"
                  justifyContent="space-between"
                  gap={1.5}
                >
                  <Typography fontSize={14}>
                    {company?.unitCode} UNID
                  </Typography>
                  <Typography fontSize={14}>
                    {company?.cutoffDate ?? '-'}
                  </Typography>
                  {company?.planType ? (
                    <Typography
                      fontWeight={700}
                      color={PLAN_TYPE_COLOR[company?.planType]}
                      variant="text"
                    >
                      {PLAN_TYPE_NAME[company?.planType]}
                    </Typography>
                  ) : (
                    <Typography fontWeight={700}>-</Typography>
                  )}
                </Stack>
              </Stack>
              <StyledGrid item xs={12}>
                <ActionButton
                  onClick={() => handleEdit(company?.id)}
                  color="secondary"
                  variant="contained"
                  size="small"
                  fullWidth
                  endIcon={
                    <Icon
                      color={NEW_COLORS.BASE.WHITE}
                      name="actions-b2b-chevron-right"
                      size={20}
                    />
                  }
                >
                  Ver detalhes
                </ActionButton>
              </StyledGrid>
            </Line>
          </Grid>
        ))}
      </Grid>
    </InfiniteScroll>
  );
}
